import type { CardTopBorderColor } from '@/common/ui/Card/Card'
import type { ProductCardLlmBlockTypes } from '@/common/api/client/types.gen'

export const DASHBOARD_BLOCK_TYPES: ProductCardLlmBlockTypes[] = [
    'MAIN_CONTENT',
    'ADDITION_VISUAL_ELEMENTS',
    'DESCRIPTION_CONTENT',
    'TITLE_SCORE',
]

export const BLOCK_TOP_BORDER: Record<ProductCardLlmBlockTypes, CardTopBorderColor | undefined> = {
    MAIN_CONTENT: 'purple',
    ADDITION_VISUAL_ELEMENTS: 'blue',
    DESCRIPTION_CONTENT: 'green',
    TITLE_SCORE: 'orange',
    VISUAL_MATCHING: undefined,
    SELLING_POWER: undefined,
    DESCRIPTION_ANALYSIS: undefined,
    IMPROVEMENTS: undefined,
}

/** Цвета заголовков секций — совпадают с border-top в Card (card.css). */
export const BLOCK_TITLE_TEXT_CLASS: Record<CardTopBorderColor, string> = {
    purple: 'text-[#8b5cf6]',
    blue: 'text-[#3b82f6]',
    green: 'text-[#08ac81]',
    orange: 'text-[#f59e0b]',
}

export const BLOCK_SECTION_TITLE: Record<ProductCardLlmBlockTypes, string> = {
    MAIN_CONTENT: 'Основной контент',
    ADDITION_VISUAL_ELEMENTS: 'Доп. визуальные',
    DESCRIPTION_CONTENT: 'Контент описания',
    TITLE_SCORE: 'Оценка заголовка',
    VISUAL_MATCHING: 'Визуальное соответствие',
    SELLING_POWER: 'Продающая сила',
    DESCRIPTION_ANALYSIS: 'Анализ описания',
    IMPROVEMENTS: 'Рекомендации по улучшению',
}

export const formatScoreValue = (value: number, fractionDigits = 1) =>
    Number.isInteger(value) ? String(value) : value.toFixed(fractionDigits)

export const formatCatalogPercent = (percents: number | undefined) =>
    percents != null ? `${Math.round(percents)}% каталога` : ''

export type ProductScoreTier = 'success' | 'warning' | 'error'

/** Пороги как в summary-карточках: ≥8 — хорошие, 6–7 — средние, <6 — слабые. */
export const getProductScoreTier = (score: number): ProductScoreTier => {
    if (score >= 8) return 'success'
    if (score >= 6) return 'warning'
    return 'error'
}

export const productScorePillClass: Record<ProductScoreTier, string> = {
    success: 'bg-[#08AC81]/15 text-[#08AC81]',
    warning: 'bg-[#F59E0B]/15 text-[#F59E0B]',
    error: 'bg-[#FF484B]/15 text-[#FF484B]',
}

/** Пороги наличия элемента в сегменте: ≥75% — хорошо, 40–74% — средне, <40% — плохо. */
export const getSegmentPresenceTier = (percent: number): ProductScoreTier => {
    if (percent >= 75) return 'success'
    if (percent >= 40) return 'warning'
    return 'error'
}
